import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme, customVariant }) => ({
  borderRadius: 12,
  textTransform: 'none',
  fontWeight: 600,
  minHeight: 44,
  padding: '8px 24px',
  fontSize: '0.875rem',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 4px 14px rgba(69, 39, 160, 0.2)',
  },
  ...(customVariant === 'primary' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  ...(customVariant === 'secondary' && {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  }),
  ...(customVariant === 'outline' && {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
  }),
  ...(customVariant === 'text' && {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  }),
}));

export const CustomButton = ({
  variant = 'primary',
  loading = false,
  children,
  disabled,
  ...props
}) => {
  // Extract custom props to prevent them from being passed to DOM
  const { customVariant: _, ...domProps } = props;

  return (
    <StyledButton
      customVariant={variant}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
      {...domProps}
    >
      {children}
    </StyledButton>
  );
};
